export const SCHEDULED_PICKUPS_VIEW_ID = 'scheduled-pickups';
export const SHIPMENT_PICKUPS_VIEW_ID = 'shipment-pickups';
export const RETURNS_VIEW_ID = 'returns';
export const USPS_PICKUP_VIEW_ID = 'usps-pickups';
export const IN_TRANSIT_VIEW_ID = 'shipped-in-transit';
export const END_OF_DAY_CATEGORY_VIEW_ID = 'end-of-day-category';
export const END_OF_DAY_VIEW_ID = 'end-of-day';
export const CONTAINER_SHIPMENTS_VIEW_ID = 'container-shipments';
export const DELIVERED_VIEW_ID = 'shipped-delivered';
export const DELIVERY_EXCEPTION_VIEW_ID = 'shipped-delivery-exceptions';
export const VOIDED_VIEW_ID = 'shipped-voided';
export const REFUND_ASSIST_VIEW_ID = 'refund-assist';
export const BATCHES_VIEW_ID = 'batches';
export const BATCHES_PROCESSED_VIEW_ID = 'batches-processed';
export const BATCHES_OPEN_VIEW_ID = 'batches-open';
export const BATCHES_ARCHIVED_VIEW_ID = 'batches-archived';
export const SHIPPED_VIEW_ID = 'shipped';
export const RECENT_VIEW_ID = 'shipped-recent';
export const ADVANCED_SEARCH_VIEW_ID = 'advanced-search';
export const BATCHES_ADVANCED_SEARCH_VIEW_ID = 'batches-advanced-search';
export const RETURNS_ADVANCED_SEARCH_VIEW_ID = 'returns-advanced-search';
export const FULFILLMENTS_VIEW_ID = 'fulfillments';
export const FULFILLMENTS_RECENT_VIEW_ID = 'fulfillments-recent';
export const FULFILLMENTS_PENDING_VIEW_ID = 'fulfillments-pending';
export const FULFILLMENTS_IN_TRANSIT_VIEW_ID = 'fulfillments-in-transit';
export const FULFILLMENTS_DELIVERED_VIEW_ID = 'fulfillments-delivered';
export const FULFILLMENTS_DELIVERY_EXCEPTION_VIEW_ID = 'fulfillments-delivery-exception';
export const FULFILLMENTS_CANCELLED_VIEW_ID = 'fulfillments-cancelled';
export const FULFILLMENTS_RETURNS_VIEW_ID = 'fulfillments-returns';
export const FULFILLMENTS_ADVANCED_SEARCH_VIEW_ID = 'fulfillments-advanced-search';

export const shipmentGridViewIdConstants = [
  SHIPPED_VIEW_ID,
  RECENT_VIEW_ID,
  IN_TRANSIT_VIEW_ID,
  DELIVERED_VIEW_ID,
  DELIVERY_EXCEPTION_VIEW_ID,
  FULFILLMENTS_VIEW_ID,
  FULFILLMENTS_RECENT_VIEW_ID,
  FULFILLMENTS_PENDING_VIEW_ID,
  FULFILLMENTS_IN_TRANSIT_VIEW_ID,
  FULFILLMENTS_DELIVERED_VIEW_ID,
  FULFILLMENTS_DELIVERY_EXCEPTION_VIEW_ID,
  FULFILLMENTS_CANCELLED_VIEW_ID,
  FULFILLMENTS_RETURNS_VIEW_ID,
  RETURNS_VIEW_ID,
  END_OF_DAY_CATEGORY_VIEW_ID,
  END_OF_DAY_VIEW_ID,
  CONTAINER_SHIPMENTS_VIEW_ID,
  SHIPMENT_PICKUPS_VIEW_ID,
  USPS_PICKUP_VIEW_ID,
  SCHEDULED_PICKUPS_VIEW_ID,
  BATCHES_VIEW_ID,
  BATCHES_OPEN_VIEW_ID,
  BATCHES_PROCESSED_VIEW_ID,
  BATCHES_ARCHIVED_VIEW_ID,
  VOIDED_VIEW_ID,
  REFUND_ASSIST_VIEW_ID,
  ADVANCED_SEARCH_VIEW_ID,
  BATCHES_ADVANCED_SEARCH_VIEW_ID,
  RETURNS_ADVANCED_SEARCH_VIEW_ID,
  FULFILLMENTS_ADVANCED_SEARCH_VIEW_ID,
];
